export default __webpack_public_path__ + "static/media/blueCrossIcon.b0fc8f57.svg";